module.exports = __webpack_public_path__ + "img/robot.3c20966e.png";